module.exports = __webpack_public_path__ + "media/images/app/toast/error-cc756b65f936bcdf82a86f777ac9febb.svg";